import createDebug from 'debug';

export const debug = createDebug('dns-sd');
